(function() {
  if (window.__servicesGlobalSwiperLoaded) {
    return;
  }

  window.__servicesGlobalSwiperLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 1023px)');
  const instances = new WeakMap();

  function initSection(section) {
    if (instances.has(section) || typeof Swiper === 'undefined') {
      return;
    }

    const container = section.querySelector('.services-global__swiper');

    if (!container) {
      return;
    }

    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 800,
      loop: false,
      allowTouchMove: true,
      centeredSlides: false,
      breakpoints: {
        120: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        769: {
          slidesPerView: 1.5,
          spaceBetween: 10
        },
        1240: {
          slidesPerView: 4,
          spaceBetween: 10
        }
      }
    };

    const scrollbar = section.querySelector('.swiper-scrollbar');
    const pagination = section.querySelector('.swiper-pagination');

    if (scrollbar) {
      swiperOptions.scrollbar = {
        el: scrollbar,
        draggable: true
      };
    }

    if (pagination) {
      swiperOptions.pagination = {
        el: pagination,
        type: 'progressbar',
      }
    }

    const swiper = new Swiper(container, swiperOptions);

    instances.set(section, swiper);
  }

  function destroySection(section) {
    const swiper = instances.get(section);

    if (!swiper) {
      return;
    }

    swiper.destroy(true, true);
    instances.delete(section);
  }

  function syncState() {
    const sections = document.querySelectorAll('.services-global');

    sections.forEach(function(section) {
      if (mobileQuery.matches) {
        initSection(section);
      } else {
        destroySection(section);
      }
    });
  }

  function syncWhenSwiperReady() {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(syncWhenSwiperReady, 120);
      return;
    }

    syncState();
  }

  let resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(syncState, 120);
  }

  document.addEventListener('DOMContentLoaded', syncWhenSwiperReady);
  document.addEventListener('shopify:section:load', syncWhenSwiperReady);
  window.addEventListener('resize', onResize);
})();
